export default __webpack_public_path__ + "static/media/10.48599927.svg";